/**
 * Auf portal. und status. sperrt Caddy die Backoffice-API (siehe deploy/Caddyfile). Meldet sich dort
 * jemand vom Team an, gehört er nach intern. – diese Funktion liefert die passende Adresse.
 * Lokal (localhost, Vorschau) gibt es keine Trennung: dann null.
 */
export function internAdresse(host: string = window.location.hostname): string | null {
  const [erstes, ...rest] = host.split(".");
  if ((erstes === "portal" || erstes === "status") && rest.length >= 2) {
    return `https://intern.${rest.join(".")}/`;
  }
  return null;
}
